import { useFormikContext } from "formik";
import React from "react";
import RadioButtonGroup from "../../Atoms/Inputs/RadioButtons/RadioButtonGroup";
import TextContainer from "../../Atoms/CustomizedAtoms/TextContainer";
import TextArea from "../../Atoms/Inputs/TextArea";
import styles from "./RecomendationPage.module.css";
import TextInput from "../../Atoms/Inputs/TextInput";
import RecomendationTable from "./RecomendationTable";
const radioOptions = [
  { label: "0-6 months", value: 0 },
  { label: "6-12 months", value: 1 },
  { label: "1-2 years", value: 2 },
  { label: "2 or more years", value: 3 },
];
const radioOptions2 = [
  { label: "Supervisor", value: 4 },
  { label: "Colleague", value: 5 },
  { label: "Other", value: 6 },
];
const FillRecomendationForm = () => {
  const formik = useFormikContext();

  console.log("fvdvd", formik);
  return (
    <div className={styles["recomendation-subContainer"]}>
      <h3>Recomendation Form</h3>

      <div>
        <RadioButtonGroup
          label='How long you know the applicant?'
          options={radioOptions}
          selectedValue={formik.values.howLongYouKnowAdmin}
          onRadioChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          required
          name='howLongYouKnowAdmin'
          errors={formik.errors.howLongYouKnowAdmin}
          touched={formik.touched.howLongYouKnowAdmin}
        />
        {formik.errors?.howLongYouKnowAdmin &&
          formik.touched?.howLongYouKnowAdmin && (
            <p className={styles.errorMessage}>
              {formik.errors.howLongYouKnowAdmin}
            </p>
          )}
      </div>
      <div className={`${styles.grid}`}>
        <div>
          <RadioButtonGroup
            label='What context?'
            options={radioOptions2}
            selectedValue={formik.values.context}
            onRadioChange={(name, value) => {
              formik.setFieldValue(name, value);
            }}
            required
            name='context'
            errors={formik.errors.context}
            touched={formik.touched.context}
          />
          {formik.errors?.context && formik.touched?.context && (
            <p className={styles.errorMessage}>{formik.errors.context}</p>
          )}
        </div>

        {formik?.values?.context === 2 && (
          <TextInput
            name='otherContext'
            value={formik.values.otherContext}
            onChange={(name, value) => {
              formik.setFieldValue(name, value);
            }}
            errors={formik.errors.otherContext}
            touched={formik.touched.otherContext}
            height='30px'
          />
        )}
      </div>

      <RecomendationTable />

      <TextArea
        label='Please mention any behavior traits that you have observed that best represent this applicant’s personality and ability to perform at university.'
        rows='6'
        required
        name='personalityText'
        value={formik.values.personalityText}
        onChange={(name, value) => formik.setFieldValue(name, value)}
        errors={formik.errors.personalityText}
        touched={formik.touched.personalityText}
      />
      <TextArea
        label='Additional Comments'
        rows='6'
        required
        name='additionalComments'
        value={formik.values.additionalComments}
        onChange={(name, value) => formik.setFieldValue(name, value)}
        errors={formik.errors.additionalComments}
        touched={formik.touched.additionalComments}
      />
      <div className={styles["grid3"]}>
        <TextInput
          label='Evaluator Name'
          name='evaluatorName'
          required
          value={formik.values.evaluatorName}
          onChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          errors={formik.errors.evaluatorName}
          touched={formik.touched.evaluatorName}
        />{" "}
        <TextInput
          label='Title/Position'
          name='titlePosition'
          value={formik.values.titlePosition}
          onChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          required
          errors={formik.errors.titlePosition}
          touched={formik.touched.titlePosition}
        />{" "}
        <TextInput
          label='Company'
          name='company'
          value={formik.values.company}
          required
          onChange={(name, value) => {
            formik.setFieldValue(name, value);
          }}
          errors={formik.errors.company}
          touched={formik.touched.company}
        />
      </div>
    </div>
  );
};

export default FillRecomendationForm;
